import PropTypes from 'prop-types'
import ReactECharts from 'echarts-for-react'
import { createDonutChartOption } from '../../../utils/chartUtils'

/**
 * Facility Distribution Chart
 *
 * Shows distribution of health facilities by level as a donut chart
 */
function FacilityDistribution({ data, title, narrative, templateText }) {
  if (!data || data.length === 0) {
    return (
      <div className="bg-white p-6 rounded-lg border border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
        <p className="text-gray-600 text-sm">
          No facility distribution data available.
        </p>
      </div>
    )
  }

  const chartOption = createDonutChartOption(data, title)

  return (
    <div className="bg-white p-6 rounded-lg border border-gray-200">
      <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>

      {/* Narrative or template text */}
      {(narrative || templateText) && (
        <div className="prose prose-lg mb-4">
          <p className="text-gray-700 leading-relaxed">
            {narrative || templateText}
          </p>
        </div>
      )}

      {/* Chart */}
      <div className="h-96">
        <ReactECharts
          option={chartOption}
          style={{ height: '100%', width: '100%' }}
          opts={{ renderer: 'canvas' }}
          theme="ug-dashboard"
        />
      </div>

      {/* Legend summary */}
      <div className="mt-4 grid grid-cols-2 md:grid-cols-3 gap-3">
        {data.map((item, index) => (
          <div key={index} className="flex items-center gap-2">
            <div
              className="w-3 h-3 rounded-full"
              style={{ backgroundColor: item.itemStyle.color }}
            />
            <span className="text-sm text-gray-700">
              {item.name}: {item.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

FacilityDistribution.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      itemStyle: PropTypes.shape({
        color: PropTypes.string,
      }),
    })
  ).isRequired,
  title: PropTypes.string.isRequired,
  narrative: PropTypes.string,
  templateText: PropTypes.string,
}

export default FacilityDistribution
